export default __webpack_public_path__ + "static/media/google-btn@2x.a4e4153e.png";